import React, { FunctionComponent } from 'react';

import Typography from '@mui/material/Typography';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import ExpandIcon from '../../../../assets/icons/ExpandIcon';
import { LoadingOverlay } from '../../../../components/LoadingOverlay';
import { CardWrapper } from '../../../../components/UI/CardWrapper';
import { colorsPalette } from '../../../../theme';
import useStyles from '../../styles';
import CardNumber from '../CardNumber';
import cardStyles from './styles';

type CardProps = {
  className?: string;
  linkClassName?: string;
  title?: string;
  value?: string | number | Function | null;
  toggle?: boolean | null;
  type?: string | null;
  activeType?: string | null;
  onClick?: Function | null;
  loading?: boolean;
  chart?: boolean;
  withExpand?: boolean;
  sliderView?: boolean;
  link?: string;
};

const Card: FunctionComponent<CardProps> = ({
  className = '',
  linkClassName = '',
  title,
  value,
  children,
  toggle,
  type,
  activeType,
  onClick,
  loading = false,
  chart = true,
  withExpand = false,
  sliderView = false,
  link,
  ...rest
}) => {
  const classes = { ...useStyles(), ...cardStyles(chart, sliderView)() };
  const isActive = type === activeType && type;
  const isInitialValue = (!value && loading) || value === null;

  const handleClick = () => {
    if (!onClick || !toggle) return;
    onClick(type);
  };

  const LinkComponent = link ? Link : ({ children }) => children;

  return (
    <CardWrapper
      wrapperClass={cx(
        classes.card,
        toggle && classes.cardWithToggle,
        toggle && isActive && classes.activeCard,
        className,
      )}
      onClick={handleClick}
      data-testid={rest['data-testid']}
    >
      <LinkComponent to={link} className={cx(classes.link, linkClassName)}>
        <div className={classes.cardHeadWrapper}>
          <Typography variant="h4" component="h4" className={classes.cardTitle}>
            {title}
          </Typography>

          {toggle && withExpand && (
            <div className={classes.expandIcon}>
              <ExpandIcon color={isActive ? colorsPalette.white : '#FFFFFF50'} />
            </div>
          )}
        </div>

        <div className={classes.cardBlock}>
          <CardNumber
            data-testid={type + 'CardNumber'}
            value={value}
            loading={loading}
            classes={classes}
          />

          {children && ((!isInitialValue && !chart) || chart) && (
            <div className={cx(classes.cardChildren, chart && classes.chartWrapper)}>
              {children}
            </div>
          )}
        </div>
      </LinkComponent>
      {loading && <LoadingOverlay borderRadius={5} />}
    </CardWrapper>
  );
};

export default Card;
